/**
* File: GoogleLoginButton.vue of WeTradeWeb
* Author: 阿佑[ayooooo@petalmail.com]
* Date: 2023/9/22 16:39
*/

<template>
  <div id="google">Continue with Google</div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
  name: 'GoggleLoginButton',
  setup () {
    onMounted(() => {
      (window as any).google?.accounts.id.renderButton(document.getElementById('google'), {
        theme: 'outline',
        size: 'large',
        width: '320px',
        text: 'continue_with',
        logo_alignment: 'left',
      })
    })
  },
})
</script>

<style scoped lang="scss">
</style>
